module.exports = __webpack_public_path__ + "img/followDoc_d.f386729a.png";